export const SEARCH_INIT_REQUEST = 'SEARCH_INIT_REQUEST'
export const SEARCH_CALL_REQUEST = 'SEARCH_CALL_REQUEST'
export const HOME_INIT_REQUEST = 'HOME_INIT_REQUEST'
export const CATEGORY_INIT_REQUEST = 'CATEGORY_INIT_REQUEST'
export const CATEGORY_UPDATE_REQUEST = 'CATEGORY_UPDATE_REQUEST'
export const SEARCH_UPDATE_REQUEST = 'SEARCH_UPDATE_REQUEST'

